import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) return setError("This invitation link is incomplete.");
    api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords do not match");
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password: pw });
      signIn(data.token, data.user);
      navigate("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={info ? `Welcome, ${info.name}` : "Create your account"} subtitle={info ? `Choose a password for ${info.email} to start using VA Brand Builder.` : "Setting up your invitation…"}>
      {error && <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700" data-testid="invite-error">{error}</div>}
      {info && (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <div className="space-y-1.5"><Label>Password (min 6 characters)</Label><Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="invite-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirm password</Label><Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="invite-password-confirm-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-[#3B185F] hover:bg-[#250E3F]" data-testid="invite-submit-btn">{busy ? "Creating account…" : "Create account & sign in"}</Button>
        </form>
      )}
      <Link to="/login" className="block text-center text-sm text-[#3B185F] hover:underline" data-testid="invite-back-to-login">Already have an account? Sign in</Link>
    </AuthShell>
  );
}
